import { createSlice } from '@reduxjs/toolkit';

// Type
const initialState = {
  selectedCampaignData: {},
  showCampaignDrawer: false,
  showCancelCampaignDrawer: false,
};

const campaignDrawerSlice = createSlice({
  name: 'campaignDrawer',
  initialState,
  reducers: {
    setShowCampaignDrawer: (state, { payload }) => {
      state.showCampaignDrawer = payload;
    },
    setShowCancelCampaignDrawer: (state, { payload }) => {
      state.showCancelCampaignDrawer = payload;
    },
    setSelectedCampaign: (state, { payload }) => {
      state.selectedCampaignData = payload;
    },
  },
  extraReducers: {},
});

export const { reducer: campaignDrawerReducer } = campaignDrawerSlice;
export const { setShowCampaignDrawer, setShowCancelCampaignDrawer, setSelectedCampaign } =
  campaignDrawerSlice.actions;
